import { CharacteristicDataType } from "@/models/graphql-global-types";

export const getNumberOfColumnsForDataType = (
  type: CharacteristicDataType
): number => {
  switch (type) {
    case CharacteristicDataType.FLOAT:
      return 10;
    case CharacteristicDataType.ONE_BOOLEAN_PER_CHARACTERISTIC:
      return 1;
    case CharacteristicDataType.ONE_BOOLEAN_PER_PRODUCT:
      return 1;
    case CharacteristicDataType.ONE_FLOAT_PER_CHARACTERISTIC:
      return 1;
    case CharacteristicDataType.ONE_TEXT_PER_PRODUCT:
      return 1;
    case CharacteristicDataType.TEXT:
      return 10;
    case CharacteristicDataType.BOOLEAN:
      return 10;
  }
};

export const isProductLevelCharacteristic = (
  type: CharacteristicDataType
): boolean => {
  switch (type) {
    case CharacteristicDataType.ONE_BOOLEAN_PER_PRODUCT:
    case CharacteristicDataType.ONE_TEXT_PER_PRODUCT:
      return true;
  }

  return false;
};

export const getSortGroupForDtaType = (
  type: CharacteristicDataType
): number => {
  switch (type) {
    case CharacteristicDataType.FLOAT:
      return 1;
    case CharacteristicDataType.ONE_BOOLEAN_PER_CHARACTERISTIC:
      return 1;
    case CharacteristicDataType.ONE_BOOLEAN_PER_PRODUCT:
      return 3;
    case CharacteristicDataType.ONE_FLOAT_PER_CHARACTERISTIC:
      return 1;
    case CharacteristicDataType.ONE_TEXT_PER_PRODUCT:
      return 2;
    case CharacteristicDataType.TEXT:
      return 1;
    case CharacteristicDataType.BOOLEAN:
      return 1;
  }
};

export const isTextCharacteristic = (type: CharacteristicDataType): boolean => {
  switch (type) {
    case CharacteristicDataType.TEXT:
    case CharacteristicDataType.ONE_TEXT_PER_PRODUCT:
      return true;
  }

  return false;
};

export const isBooleanCharacteristic = (
  type: CharacteristicDataType
): boolean => {
  switch (type) {
    case CharacteristicDataType.BOOLEAN:
    case CharacteristicDataType.ONE_BOOLEAN_PER_CHARACTERISTIC:
    case CharacteristicDataType.ONE_BOOLEAN_PER_PRODUCT:
      return true;
  }

  return false;
};

export const isFloatCharacteristic = (
  type: CharacteristicDataType
): boolean => {
  switch (type) {
    case CharacteristicDataType.FLOAT:
    case CharacteristicDataType.ONE_FLOAT_PER_CHARACTERISTIC:
      return true;
  }

  return false;
};
